import { spawn, call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { workFlowActions } from '../../../application/actions/workFlow';
import { appActions } from '../../../application/actions/aplication'

import api from '../../api/index';

const apiRequest = api(process.env.REACT_APP_HOST);

// ATIVITY
export function* activitiesGetAllFetch(e) {
    yield put(workFlowActions.connectionWorkFlowActivities({ connection: true }));
    yield put(appActions.conexionApp({ connection: true }))
    try {

        const url = `activity`
        const response = yield call(
            apiRequest.get,
            url
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(workFlowActions.createWorkFlowActivities({ data }));
    } catch (err) {
        yield put(workFlowActions.errorWorkFlowActivities({ error: true, message: err.message }));
    } finally {
        yield put(workFlowActions.connectionWorkFlowActivities({ connection: false }));
        yield put(appActions.conexionApp({ connection: false }))
    }
}

// STATES
export function* statesGetAllFetch(e) {
    yield put(workFlowActions.connectionWorkFlowSatates({ connection: true }));
    yield put(appActions.conexionApp({ connection: true }))
    try {

        const url = `workflow`
        const response = yield call(
            apiRequest.get,
            url
        );

        // Extraigo todos los datos
        const { data } = response;
        yield put(workFlowActions.createWorkFlowSatates({ data }));
    } catch (err) {
        yield put(workFlowActions.errorWorkFlowSatates({ error: true, message: err.message }));
    } finally {
        yield put(workFlowActions.connectionWorkFlowSatates({ connection: false }));
        yield put(appActions.conexionApp({ connection: false }))
    }
}

export function* watchFetchSesion() {
    yield takeLatest(workflowActionsSaga.activitiesGetAll.type, activitiesGetAllFetch);
    yield takeLatest(workflowActionsSaga.statesGetAll.type, statesGetAllFetch);
}

export default function* rootSaga() {
    yield spawn(watchFetchSesion);
}


const activitiesGetAll = createAction('workflowSaga/activitiesGetAll');
const statesGetAll = createAction('workflowSaga/statesGetAll');

export const workflowActionsSaga = {
    activitiesGetAll,
    statesGetAll
};
